import { useState } from 'react';
import { ChatUploadSummary } from '../../interfaces/ChatInterface';
import Panel from '../reusable/Panel';
import ChatBreadcrumbs from './ChatBreadcrumbs';
import ChatInput from './ChatInput';
import { SAMPLE_PROMPTS } from './predefinedPrompts';

interface ChatComposerProps {
  eoaId: string;
  accessToken: string;
  scope: string;
  userName?: string;
  onSubmit: (prompt: string, attachments?: ChatUploadSummary[]) => void;
  onBack?: () => void;
}

const firstNameOf = (fullName?: string): string => (fullName ?? '').trim().split(' ')[0] ?? '';

const ChatComposer = ({ eoaId, accessToken, scope, userName, onSubmit, onBack }: ChatComposerProps) => {
  const [input, setInput] = useState('');

  const handleSend = (attachments: ChatUploadSummary[]) => {
    const trimmed = input.trim();
    if (!trimmed) return;
    setInput('');
    onSubmit(trimmed, attachments);
  };

  const firstName = firstNameOf(userName);
  const greeting = firstName ? `Hi ${firstName}` : 'Hi there';

  const composerBody = (
    <div className="chat-composer-body">
      <div className="chat-greeting">
        <p className="chat-greeting-title">{greeting}</p>
        <p className="chat-greeting-subtitle">
          I&apos;m ready to help you find relevant information and create a draft report. Where shall we begin?
        </p>
      </div>

      <ChatInput
        value={input}
        onChange={setInput}
        onSend={handleSend}
        eoaId={eoaId}
        accessToken={accessToken}
        scope={scope}
        placeholder="Type here or select one of the prompts below to get started"
      />

      <div className="chat-prompts">
        <div className="chat-prompt-category">
          <p className="chat-prompts-heading">Sample prompts</p>
          <div className="chat-prompts-list">
            {SAMPLE_PROMPTS.map((prompt) => (
              <button key={prompt} type="button" className="chat-prompt" onClick={() => onSubmit(prompt)}>
                {prompt}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  if (onBack) {
    return (
      <div className="chat-composer">
        <ChatBreadcrumbs currentLabel="New chat" onOverview={onBack} />
        {composerBody}
      </div>
    );
  }

  return (
    <div className="chat-composer chat-composer--landing">
      <Panel className="chat-composer-panel">{composerBody}</Panel>
    </div>
  );
};

export default ChatComposer;
